/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BookingApi} from '../api/booking.api';
import { switchMap, map } from 'rxjs/operators';
import { BookingData,Bookings } from '../../../interfaces/masters/booking';

@Injectable()
export class BookingService extends BookingData {

  constructor(private api: BookingApi) {
    super();
  }


  list(): Observable<Bookings[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Bookings>{
      return this.api.getById(url);
  }

  create(url: string, data:Bookings): Observable<Bookings> {
    return this.api.add(url,data);
  }

  update(url: string, data:Bookings): Observable<Bookings> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
